export const LOGIN = "authenticate/LOGIN";
export const REQUEST_COMPLETE = "authenticate/REQUEST_COMPLETE";
export const REQUEST_SUCCESS = "authenticate/REQUEST_SUCCESS";
export const REQUEST = "authenticate/REQUEST";
export const REQUEST_FAIL = "authenticate/REQUEST_FAIL";
export const REQUEST_MYSELF_FAIL = "authenticate/REQUEST_MYSELF_FAIL";
export const REQUEST_MYSELF_SUCCESS = "authenticate/REQUEST_MYSELF_SUCCESS";
